import {
  curry, converge, assocPath, pathOr, identity,
} from 'ramda';

// Add property with default value if property not present,
// if property already exists do not change its value.
/* eslint max-len: 0 */
const addPropOr = curry((defaultValue, path, obj) => converge(assocPath(path), [pathOr(defaultValue, path), identity])(obj));

export default addPropOr;
